// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1_d8r","productName":"Table_productName__1oLd0"};